module.exports = __webpack_public_path__ + "img/DemonDagger_dagger.306da1a3.png";